import * as React from 'react'
import styled from 'styled-components'
import { media } from '../../../utils'

const error = require('src/assets/wizard/error_cross.png')
const valid = require('src/assets/wizard/check.png')

export const TInput = styled.input`
  position: relative;
  width: calc(100% - 15px);
  margin: 10px 5px;
  padding: 7.5px;
  font-size: 16px;
  border: none;
  border-radius: 0;
  border-bottom: 2px solid #a7c9cd;
  outline: none;
  text-align: ${(props) => (props.centered ? 'center' : 'left')};
  &::placeholder {
    color: #9a9a9a;
  }
  ${(props) => !props.valid && 'border-color: #974353;'}
`
TInput.defaultProps = {
  valid: true
}

const ValidIcon = styled.img`
  position: absolute;
  width: 12px;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  ${media.tablet`right: 7.5px;`}
  ${media.phone`right: 0;`}
`

interface TextInputProps {
  name: string
  placeholder: string
  value: string
  onChange: (t: string) => void
  validate?: (t: string) => boolean
  type?: string
  centered?: boolean
}
type Validity = 'NOT_CHECKED' | 'VALID' | 'INVALID'

const TextInput = (props: TextInputProps) => {
  const { name, placeholder, onChange, validate, value, type, centered } = props
  const [validity, setValidity] = React.useState<Validity>('NOT_CHECKED')

  const handleBlur = (t) => {
    if (!validate) setValidity('VALID')
    else if (t !== '') setValidity(validate(t) ? 'VALID' : 'INVALID')
  }

  const handleChange = (t) => {
    if (validate) {
      if (t.length - value.length > 2) {
        // If something is pasted (e.g. from Google auto suggest)
        // validation should instantly be performed
        handleBlur(t)
      } else if (t === '') {
        setValidity('INVALID')
      } else {
        setValidity('NOT_CHECKED')
      }
    }
    onChange(t)
  }

  // Used so that if there are initial values they are immediately validated
  React.useEffect(() => {
    handleBlur(value)
  }, [])

  return (
    <div style={{ position: 'relative' }}>
      <TInput
        id={name}
        value={value}
        onChange={(e) => handleChange(e.target.value)}
        onBlur={(e) => handleBlur(e.target.value)}
        name={name}
        placeholder={placeholder}
        type={type || 'text'}
        valid={validity !== 'INVALID'}
        centered={centered}
      />
      {validity === 'VALID' && validate && <ValidIcon src={valid} alt='v' />}
      {validity === 'INVALID' && validate && <ValidIcon src={error} alt='e' />}
    </div>
  )
}

export default TextInput



// WEBPACK FOOTER //
// ./src/components/atoms/input/TextInput.tsx